import {ProductNamesLabel} from '../../constants/products';
import {SubscriptionBillingCycleType} from '../../../userway/sdk/UserWayApiClient';
import {BillingCycleType} from '../../types/payment.type';

export function getPlanPeriodFromBillingCycle(plan: BillingCycleType, formType: 'a11-plan' | 'addon'): string {
  switch (plan) {
    case SubscriptionBillingCycleType.MONTHLY:
      return formType === 'a11-plan' ? '1-month' : 'monthly';

    case SubscriptionBillingCycleType.ANNUAL:
      return '1-year';

    case SubscriptionBillingCycleType.BIANNUAL:
      return '2-year';
  }
}

export function getAddonLabelFromType(addonType: ProductNamesLabel): string {
  switch (addonType) {
    case ProductNamesLabel.LIVE_TRANSLATIONS:
      return 'translation';

    case ProductNamesLabel.USAGE_STATS:
      return 'usage-stats';

    case ProductNamesLabel.MODIFY_MENU:
      return 'modify-menu';

    case ProductNamesLabel.REMEDIATION:
      return 'remediation';
  }
}
